type ArgsTypeMultiParam<F extends (...x: any[]) => any> = F extends (
  ...x: infer A
) => any
  ? A
  : never;

type ArgsType<F extends (x: any) => any> = F extends (x: infer A) => any
  ? A
  : never;

export function toMultiParamThunk<TFunc extends (...args: any[]) => any>(
  func: TFunc
): (params: ArgsTypeMultiParam<TFunc>) => () => ReturnType<typeof func> {
  return (params: ArgsTypeMultiParam<TFunc>) => () =>
    func.apply(undefined, params);
}

export function toThunk<TFunc extends (arg: any) => any>(
  func: TFunc
): (params: ArgsType<TFunc>) => () => ReturnType<typeof func> {
  return (params: ArgsType<TFunc>) => () => func.apply(undefined, params);
}
